const iconColors = {
  primary: '#FFFFFF',
  onHover: '#0A3A99',
  disable: '#0A3A99',
  onHoverEndCall: '#710A0A',
};

export default iconColors;
